export default {
    path: '/general/online-pre-registration',
    component: () =>
      import('@/views/general-reports/online-pre-registration/Wrapper.vue'),
    children: [
      {
        path: '',
        name: 'online-pre-registration',
        component: () =>
          import('@/views/general-reports/online-pre-registration/Main.vue'),
      },
    ],
  }
  